<input #fileInput type="file" (change)="onFileInput($event)" style="display:none;"/>

<div class="d-flex align-items-center">
  <div class="align-items-end">
    <button type="button" class="btn btn-sm btn-outline-theme" (click)="fileInput.click()"><i class="fi fi-br-upload me-2"></i>
      <span *ngIf="(!preview || preview === null) && (!fileName || fileName === null)">Select a file</span>
      <span *ngIf="(preview && preview !== null) || (fileName && fileName !== null)">Change file</span>
    </button>
  </div>
  <div>
    <a class="file-preview bg-light-theme d-inline-flex align-items-center ms-3" *ngIf="fileName">
      <i class="fi fi-br-file me-2"></i> File Selected <i (click)="removeDoc()" class="fi fi-br-cross-circle ms-3 remove-doc"></i>
    </a>
  </div>

</div>
<p class="mb-0 mt-2" *ngIf="type !== 'image'"><small>PDF, JPG, GIF, PNG, Max Size 2MB</small></p>

